import './ManagePanels.scss';

export { default } from './ManagePanels';
